<div class="modal-body modal-max">
  <div class="layout-auto-1-auto-1-auto">
    <h5 class="modal-header">{{getRessource('ModalHeaderProfilePic')}}</h5>
    <div class="content">
      <div class="mycanvas">
        <canvas #pictureCanvas class="test" (mousewheel)="onScrollCanvas($event)"
                (mousemove)="handleMoveEvent($event)"
                (mousedown)="setClickedBoolAndCoords(true,$event)"
                (mouseup)="setClickedBoolAndCoords(false,$event)"
                (mouseout)="setClickedBoolAndCoords(false,$event)"
                (touchstart)="setClickedBoolAndCoords(true, $event)"
                (touchmove)="$event.preventDefault();handleMoveEvent($event)"
                (touchend)="setClickedBoolAndCoords(false, $event)"
        > </canvas>
      </div>
      <div class="grid-auto-1">
        <label class="md-btn" type="button" for="uploadInput">{{getRessource('LabelChangeZoom')}}</label>
        <input #slide type="range" step="0.1" style="border-bottom: 0px!important; box-shadow: none!important" [value]="zoom.scaleValue" [max]="zoom.max" [min]="zoom.min"
               (change)="onScrollScale(slide.value)">
      </div>
    </div>
    <div class="spawn-modal-actions">
      <button class="md-btn" (click)="cancel()">{{getGlobal('Cancel')}}</button>
      <button class="md-btn" (click)="save()">{{getGlobal('Apply')}}</button>
    </div>
  </div>
  <input #ImageFile id="uploadInput" type="file" style="display:none" accept="image/*" (change)="onFileChange($event)">
</div>
